export default function(obj) {
  return JSON.parse(JSON.stringify(obj));
}


// WEBPACK FOOTER //
// ./helpers/clone.js